import supabase from '@/utils/supabase';
import { useLoaderData } from 'react-router';
import { Card, CardHeader, CardContent, CardTitle } from '@/components/ui/card';
import { formatDate } from '@/lib/utils';
import { Button } from '@/components/ui/button';

export async function loader() {
  const { data: token, error } = await supabase
    .from('frameio_tokens')
    .select('updated_at')
    .order('created_at', { ascending: false })
    .limit(1)
    .maybeSingle();
  if (error || !token) {
    throw new Response('Failed to load token status', { status: 500 });
  }
  return { token };
}

export default function EngineVideo() {
  const { token } = useLoaderData();
  const refreshExpiresAt = new Date(token.updated_at);
  refreshExpiresAt.setDate(refreshExpiresAt.getDate() + 14);

  const now = new Date();
  const daysRemaining = Math.floor(
    (refreshExpiresAt.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)
  );

  const isExpired = daysRemaining < 0;

  const handleAuth = async () => {
    const {
      data: { session },
    } = await supabase.auth.getSession();
    const response = await fetch('/api/engine/video/frameio/auth', {
      headers: { Authorization: `Bearer ${session?.access_token}` },
    });
    const { authUrl } = await response.json();
    if (authUrl) {
      window.open(authUrl, '_blank');
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Frame.io</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex justify-start gap-10">
          <span className="text-muted-foreground text-sm">
            Refresh token expires
          </span>
          <span>{formatDate(refreshExpiresAt.toString())}</span>
        </div>
        <div className="flex justify-start gap-10">
          <span className="text-muted-foreground text-sm">Days Remaining</span>
          <span className={isExpired ? 'text-red-500' : ''}>
            {isExpired
              ? `Expired ${Math.abs(daysRemaining)} days ago`
              : `${daysRemaining} days`}
          </span>
        </div>
        <Button
          className="cursor-pointer mt-4"
          onClick={handleAuth}
          variant={isExpired ? 'destructive' : 'outline'}
        >
          {isExpired ? 'Re-authenticate' : 'Refresh token'}
        </Button>
      </CardContent>
    </Card>
  );
}
